module.exports = __webpack_public_path__ + "static/img/02_click.09c4795c.png";